import { File as GQLFile } from '../../../generated/graphql';

export type DocumentViewerKind = 'pdf' | 'image' | 'other';

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif']);

const getExtension = (fileName: string): string => fileName.split('.').pop()?.toLowerCase() ?? '';

export const getDocumentViewerKind = (file: Pick<GQLFile, 'name' | 'contentType'>): DocumentViewerKind => {
  const extension = getExtension(file.name);
  if (file.contentType === 'application/pdf' || extension === 'pdf') return 'pdf';
  if (file.contentType.startsWith('image/') || IMAGE_EXTENSIONS.has(extension)) return 'image';
  return 'other';
};
